/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DailyMetrics } from '../../models/daily-metrics';

export interface GetHarvestTarget$Params {
  facilityGroupId: number;
  fromDate?: string;
}

export function getHarvestTarget(http: HttpClient, rootUrl: string, params: GetHarvestTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DailyMetrics>>> {
  const rb = new RequestBuilder(rootUrl, getHarvestTarget.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.query('fromDate', params.fromDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DailyMetrics>>;
    })
  );
}

getHarvestTarget.PATH = '/api/liveTargetDataByHouse/facilityGroupId/{facilityGroupId}';
